import React from 'react';
import { Routes, Route, Link, Switch } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';

import { useLocation } from 'react-router';

import Particles from 'react-tsparticles';

import {
    Backdrop,
    Navbar,
    // Cursor,
    Particles as particlesOptions,
} from './components';
import { About, Home, AnimatedPage, Products, Contact } from './containers';
import './App.css';

const App = () => {
    const location = useLocation();

    const productWidth = '200px';

    const isMobile = window.innerWidth < 600;

    return (
        <div>
            <Backdrop />
            <Navbar />
            {/* {~isMobile && <Cursor />} */}
            <Particles options={particlesOptions} />
            <AnimatePresence>
                <Routes
                    key={location.pathname}
                    location={location}
                >
                    <Route
                        exact
                        path='/'
                        element={
                            <AnimatedPage>
                                <Home />
                            </AnimatedPage>
                        }
                    />
                    <Route
                        path='/about'
                        element={
                            <AnimatedPage>
                                <About />
                            </AnimatedPage>
                        }
                    />
                    <Route
                        path='/contact'
                        element={
                            <AnimatedPage>
                                <Contact />
                            </AnimatedPage>
                        }
                    />
                    <Route
                        path='/magnets'
                        element={
                            <AnimatedPage>
                                <Products
                                    products={'Magnets'}
                                    prefix={'M'}
                                    cost={'$5 each'}
                                    size={'10cm x 7cm'}
                                    productWidth={productWidth}
                                    theme={'210, 10%'}
                                    extra={
                                        <>
                                            <li>Flexible construction.</li>
                                        </>
                                    }
                                />
                            </AnimatedPage>
                        }
                    />
                    <Route
                        path='/greetingcards'
                        element={
                            <AnimatedPage>
                                <Products
                                    products={'Greeting Cards'}
                                    prefix={'G'}
                                    cost={'$5 each'}
                                    size={'16cm x 11.5cm'}
                                    productWidth={productWidth}
                                    theme={'140, 10%'}
                                    extra={
                                        <>
                                            <li>
                                                Blank on the inside with facts
                                                about the species on the back.
                                            </li>
                                            <li>
                                                Includes one white C6 envelope.
                                            </li>
                                            <li>
                                                Printed on 100% recycled paper.
                                            </li>
                                        </>
                                    }
                                />
                            </AnimatedPage>
                        }
                    />
                    <Route
                        path='/coasters'
                        element={
                            <AnimatedPage>
                                <Products
                                    products={'Coasters'}
                                    prefix={'C'}
                                    cost={
                                        '$18 (per set) | $35 (pack of 4 assorted)'
                                    }
                                    size={'9cm x 9cm'}
                                    productWidth={productWidth}
                                    borderRadius={'4px'}
                                    theme={'70, 10%'}
                                    extra={
                                        <>
                                            <li>MDF back with gloss finish.</li>
                                        </>
                                    }
                                />
                            </AnimatedPage>
                        }
                    />
                    <Route
                        path='/stubbyholders'
                        element={
                            <AnimatedPage>
                                <Products
                                    products={'Stubby Holders'}
                                    prefix={'S'}
                                    cost={'$16 each'}
                                    size={'11cm x 7cm'}
                                    productWidth={productWidth}
                                    borderRadius={'24px'}
                                    theme={'0, 10%'}
                                    extra={
                                        <>
                                            <li>Foam sleeve.</li>
                                        </>
                                    }
                                />
                            </AnimatedPage>
                        }
                    />
                    <Route
                        path='/bookmarks'
                        element={
                            <AnimatedPage>
                                <Products
                                    products={'Bookmarks'}
                                    prefix={'B'}
                                    cost={'$3 each'}
                                    size={'15cm x 5cm'}
                                    productWidth={productWidth}
                                    theme={'35, 10%'}
                                    extra={
                                        <>
                                            <li>
                                                Printed on 100% recycled paper.
                                            </li>
                                        </>
                                    }
                                />
                            </AnimatedPage>
                        }
                    />
                    <Route
                        path='/clips'
                        element={
                            <AnimatedPage>
                                <Products
                                    products={'Clips'}
                                    prefix={'CL'}
                                    cost={'$12 each'}
                                    size={'4.2cm x 3.2cm'}
                                    productWidth={productWidth}
                                    theme={'175, 10%'}
                                    extra={
                                        <>
                                            <li>
                                                Sturdy clip with black rubber
                                                grip and magnetic backing.
                                            </li>
                                        </>
                                    }
                                />
                            </AnimatedPage>
                        }
                    />
                    <Route
                        path='/pens'
                        element={
                            <AnimatedPage>
                                <Products
                                    products={'Pens'}
                                    prefix={'P'}
                                    cost={'$8 each'}
                                    size={'14.5cm x 1.2cm'}
                                    productWidth={productWidth}
                                    theme={'105, 10%'}
                                    extra={
                                        <>
                                            <li>
                                                Elegant white barrel and black
                                                grip pen with black ink and
                                                click-action mechanism.
                                            </li>
                                        </>
                                    }
                                />
                            </AnimatedPage>
                        }
                    />
                </Routes>
            </AnimatePresence>
        </div>
    );
};

export default App;
